import React, { useState } from "react";
import { Auth } from 'aws-amplify';
import { StyleSheet, Text, TouchableOpacity, View, SafeAreaView, TextInput } from 'react-native';
import { SaveDialog } from "../components/CmnDiaLog";
import { Header } from "../components/Header";
import { appAlert, appMsg, sleep } from "../components/CmnUtil";

/** ================================
*  ユーザパスワード変更画面
*  ================================*/

const UserPasswordUpdate = ({ navigation }: { navigation: any; }) => {

  // 現在のパスワード格納State
  const [oldPassword, setOldPassword] = useState<string>("");

  // 新規パスワード格納State
  const [newPassword, setNewPassword] = useState<string>("");

  // 確認用パスワード格納State
  const [confirmationPassword, setConfirmationPassword] = useState<string>("");

  // 確認ダイアログフラグ格納State
  const [dialogFlag, setDialogFlag] = useState<boolean>(false);

  /**
   * ステートの初期化処理
   */
  const init = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmationPassword("");
  };

  /**
   * パスワードを変更する
   * @returns {Promise<string[]>} [status, message]
   */
  const updatePassword = async (): Promise<string[]> => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(user, oldPassword, newPassword);
      return ["success", "パスワードを変更しました。"];
    } catch (err: any) {
      return ["error", "パスワードの変更に失敗しました。管理者へお問い合わせください。"];
    };
  };

  const validatePassword = (txt: string) => {
    return (txt.length >= 8) && (!!txt.match(/[a-z]+/)) && (!!txt.match(/[A-Z]+/)) && (!!txt.match(/\d+/))
  }

  /**
   * ダイアログボタン押下しパスワード変更を行う。
   * パスワード変更成功後、入力した内容を消去する
   * @param input {boolean} キャンセルを押した場合false
   * @returns 
   */
  const onClickDialogButton = async (input: boolean) => {
    setDialogFlag(false);

    // キャンセル押下で何もせずリターン
    if (!input) { return; };

    let msgText: string[] = ["error", "例外が発生しました。"];
    if (newPassword != confirmationPassword) {
      msgText[1] = "確認用パスワードが異なります。";
    } else if (!validatePassword(newPassword)) {
      msgText[1] = "「8文字以上・大小英数字をそれぞれ1つ以上含む」の条件を満たしていません。";
    } else {
      await updatePassword().then((res) => msgText = res);
    };

    if (msgText[0] == "success") {
      await appMsg(msgText[1]);
      await sleep(2500);
      init();
    } else if (msgText[0] == "error") {
      await appAlert(msgText[1]);
    };
  };

  return (
    <SafeAreaView style={styles.container}>
      <SaveDialog
        cancelButtonName={"キャンセル"}
        saveButtonName={"保存"}
        canceAction={() => onClickDialogButton(false)}
        saveAction={() => onClickDialogButton(true)}
        message={"変更を保存しますか？"}
        visible={dialogFlag}
      />

      <Header onPress={() => navigation.goBack()} goBackText="＜" headerText="パスワード変更" />

      <View style={styles.formBlock}>
        <Text style={styles.formText}>現在のパスワード</Text>
        <TextInput
          style={styles.formInputName}
          value={oldPassword}
          onChangeText={setOldPassword}
          secureTextEntry={true}
        />
      </View>

      <View style={styles.formBlock}>
        <Text style={styles.formText}>新規パスワード</Text>
        <Text style={styles.formText}>※8文字以上で、大小英数字をそれぞれ1つ以上含む必要があります。</Text>
        <TextInput
          style={styles.formInputName}
          value={newPassword}
          onChangeText={setNewPassword}
          placeholder={"新規パスワードを入力してください"}
          secureTextEntry={true}
        />
      </View>

      <View style={styles.formBlock}>
        <Text style={styles.formText}>新規パスワード（確認）</Text>
        <TextInput
          style={styles.formInputName}
          value={confirmationPassword}
          onChangeText={setConfirmationPassword}
          placeholder={"再度新規パスワードを入力してください"}
          secureTextEntry={true}
        />
      </View>

      <TouchableOpacity style={styles.button} onPress={() => setDialogFlag(true)}>
        <Text style={styles.buttonText}>保存</Text>
      </TouchableOpacity>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#E2F0D9",
    position: "relative",
  },
  buttonText: {
    color: "#ffffff",
    textAlign: "center",
    fontSize: 18,
  },
  formBlock: {
    marginBottom: 15,
    paddingBottom: 15,
  },
  formInputName: {
    backgroundColor: "#FFFFFF",
    height: 40,
    fontSize: 18,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: "#417B9C",
    paddingHorizontal: 25,
  },
  formText: {
    fontSize: 18,
    marginBottom: 5,
    marginLeft: 20,
  },
  errorText: {
    marginLeft: 20,
    fontSize: 15,
    color: "#ff0000",
    position: "absolute",
    bottom: -8,
  },
  button: {
    backgroundColor: "#7AAD47",
    borderWidth: 1,
    borderColor: "#057E32",
    borderStyle: "solid",
    width: 120,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 30,
    height: 40,
    justifyContent: 'center',
    shadowColor: "#808080",
    shadowOffset: { width: 5, height: 5 },
    shadowRadius: 10,
  },
});

export default UserPasswordUpdate;